import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--ink))] text-white"
    >
      <div className="container-edge py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/30 font-display text-base">
              EG
            </span>
            <span className="font-display text-xl">EG Spanish Interpreting</span>
          </div>
          <p className="mt-5 text-white/70 leading-relaxed max-w-xs">
            A team of qualified Spanish · English interpreters for medical,
            legal, immigration, and business settings — delivered with clarity,
            care, and confidentiality.
          </p>
        </div>

        <div>
          <div className="eyebrow !text-white/60">Navigate</div>
          <ul className="mt-4 space-y-2">
            {[
              { href: "#services", label: "Services" },
              { href: "#about", label: "About" },
              { href: "#contact", label: "Contact" },
            ].map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-white/85 hover:text-[hsl(var(--accent))] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow !text-white/60">Contact</div>
          <a
            href="mailto:eginterpreting@gmail.com"
            data-testid="footer-email-link"
            className="mt-4 block font-display text-lg hover:text-[hsl(var(--accent))] transition-colors"
          >
            eginterpreting@gmail.com
          </a>
          <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[hsl(var(--accent))]">
            Preferred for job inquiries
          </p>
          <a
            href="tel:+12192627009"
            data-testid="footer-phone-link"
            className="mt-3 block font-display text-lg hover:text-[hsl(var(--accent))] transition-colors"
          >
            (219) 262-7009
          </a>
          <p className="mt-3 text-sm text-white/60">
            EGInterpreting.com · On-site &amp; Remote
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-edge py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/60">
          <span data-testid="footer-copy">
            © {new Date().getFullYear()} EG Spanish Interpreting, LLC · Founded &amp; led by Eve Gomez. All rights reserved.
          </span>
          <span className="uppercase tracking-[0.22em]">Cada palabra importa.</span>
        </div>
      </div>
    </footer>
  );
}
